export const getLicences = (state) => state.licences
export const getLicence = (state) => (licence_id) => state.licences.find(x => x.id === licence_id) || {}
export const getLicencesMeta = (state) => state.meta_data
export const getLicencesDurationType = (state) => state.licencesDurationType
export const getLicencesType = (state) => state.licencesType


